import axios from 'axios';
import { baseUrl, HttpMethods } from './base';

export interface GetCommentParams {
  perPage?: number;
  page?: number;
  order?: 'asc' | 'desc';
}
export interface GetTaskCommentsParams extends GetCommentParams {
  task_id: number;
}
export interface GetTaskCommentsPayload {
  params: GetTaskCommentsParams;
}

// Generated by https://quicktype.io

export interface GetCommentsResponse<D extends Comment, M = Meta> {
  data: D[];
  meta: M;
}

export interface Comment extends ID {
  user: CommentUser;
}

export interface TaskComment extends Comment {
  taskId: number;
}

export interface CommentUser {
  name: string;
  id: number;
  profileImageUrl: string;
}

export interface Meta {
  total: number;
}

export const getTaskComments = async (payload: GetTaskCommentsPayload) => {
  const { params } = payload;
  const res = await axios.request<GetCommentsResponse<TaskComment>>({
    method: 'GET',
    url: `/sherpa/v0/api/taskComments`,
    params: {
      page: 1,
      perPage: 3,
      order: 'desc',
      ...params,
    },
  });
  return res.data;
};

export interface PostTaskCommentPayload {
  data: {
    task_id: number;
    comment: string;
  };
}

// Generated by https://quicktype.io

export interface PostCommentResponse<D extends ID> {
  message: string;
  data: Data<D>;
}

export interface Data<T extends ID> {
  id: T;
}

export interface ID {
  id: number;
  comment: string;
  createdAt: string;
  createdBy: number;
}

export interface PostTaskComments extends ID {
  taskId: number;
}

export const postTaskComments = async (payload: PostTaskCommentPayload) => {
  const { data } = payload;
  const res = await axios.request<PostCommentResponse<PostTaskComments>>({
    method: 'POST',
    url: `/sherpa/v0/api/taskComments`,
    data,
  });
  return res.data;
};

export interface GetDeliverableCommentsParams extends GetCommentParams {
  deliverable_id: number;
}

export interface DeliverableComment extends Comment {
  deliverableId: number;
}

export const getDeliverableComments = async (
  params: GetDeliverableCommentsParams
) => {
  const res = await axios.request<GetCommentsResponse<DeliverableComment>>({
    method: 'GET',
    url: `/sherpa/v0/api/deliverableComments`,
    params: {
      page: 1,
      perPage: 3,
      order: 'desc',
      ...params,
    },
  });
  return res.data;
};

export interface PostDeliverableCommentsPayload {
  data: {
    deliverable_id: number;
    comment: string;
  };
}

export interface PostDeliverableComments extends ID {
  deliverableId: number;
}

export const postDeliverableComments = async (
  payload: PostDeliverableCommentsPayload
) => {
  const { data } = payload;
  const res = await axios.request<PostCommentResponse<PostDeliverableComments>>(
    {
      method: 'POST',
      url: `/sherpa/v0/api/deliverableComments`,
      data,
    }
  );
  return res.data;
};

export interface MilestoneComment extends Comment {
  milestoneId: number;
}

export interface GetMilestoneCommentParams extends GetCommentParams {
  milestone_id: number;
}

export const getMilestoneComments = async (
  params: GetMilestoneCommentParams
) => {
  const res = await axios.request<GetCommentsResponse<MilestoneComment>>({
    method: 'GET',
    url: `/sherpa/v0/api/milestoneComments`,
    params: {
      page: 1,
      perPage: 3,
      order: 'desc',
      ...params,
    },
  });
  return res.data;
};

export interface PostMilestoneCommentsPayload {
  data: {
    milestone_id: number;
    comment: string;
  };
}

export interface PostMilestoneComments extends ID {
  milestoneId: number;
}

export const postMilestoneComments = async (
  payload: PostMilestoneCommentsPayload
) => {
  const { data } = payload;
  const res = await axios.request<PostCommentResponse<PostMilestoneComments>>({
    method: 'POST',
    url: `/sherpa/v0/api/milestoneComments`,
    data,
  });
  return res.data;
};

export interface PartnerProposal extends Comment {
  milestoneId: number;
}

export interface GetPartnerProposalCommentsParams extends GetCommentParams {
  resource_id: number | string;
  resource_type: string;
}

export interface GetPartnerProposalCommentsPayload {
  params: GetPartnerProposalCommentsParams;
}

export const getPartnerProposalComments = async (
  payload: GetPartnerProposalCommentsPayload
) => {
  const { params } = payload;
  const res = await axios.request<GetCommentsResponse<PartnerProposal>>({
    method: 'GET',
    url: `/sherpa/v0/api/comments`,
    params: {
      ...params,
    },
  });
  return res.data;
};

export interface CommentPayload {
  data: {
    resource_id: number | string;
    comment: string;
    resource_type: string;
  };
}

export interface PostComment extends ID {
  resource_id: number | string;
}

export const postComment = async (payload: CommentPayload) => {
  const { data } = payload;
  const res = await axios.request<PostCommentResponse<PostComment>>({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/comments`,
    data,
  });
  return res.data;
};
